const checkIfMatches = (value, regex) => {
  if (!value) {
    return false;
  }

  return value.match(regex) !== null;
};

export default checkIfMatches;
